export default __webpack_public_path__ + "static/media/financial1.897f8a9b.jpg";